import { useContext } from 'react';
import * as yup from 'yup';
import _map from 'lodash/map';
import _keys from 'lodash/keys';
import _get from 'lodash/get';

import { Row, RenderConfig, TextInput, ASSET_TYPE, AssetUploadInputOnS3, SelectInput, CURRENT_YEAR } from 'commons-ui';
import { UserDetailsContext } from 'context/userDetails';

export const FORM_FIELD_KEYS = {
	DOCUMENT_TYPE: 'documentType',
	DOCUMENT_NUMBER: 'documentNumber',
	YEAR: 'year',
	FILE_NAME: 'fileName'
};

export const validationSchema = yup.object().shape({
	documentType: yup.string().required('documentType is a required field'),
	documentNumber: yup.string().required('documentNumber is a required field'),
	year: yup.number().required('year is a required field'),
	fileName: yup.string().required('fileName is a required field')
});

const DOCUMENT_TYPE_OPTIONS = {
	VOTER_ID: 'VoterId',
	DL: 'DL'
};

export const getFormConfig = () => {
	const {
		selectedUser: { uid }
	} = useContext(UserDetailsContext);

	const FORM_FIELD_CONFIG = {
		[FORM_FIELD_KEYS.DOCUMENT_NUMBER]: new RenderConfig()
			.setName('documentNumber')
			.setLabel('Number on your selected document')
			.setRenderer(TextInput)
			.setRenderProps({
				isEditable: { create: true, edit: true },
				required: true
			}),
		[FORM_FIELD_KEYS.YEAR]: new RenderConfig()
			.setName('year')
			.setLabel('Year')
			.setRenderer(SelectInput)
			.setRenderProps({
				isEditable: { create: true, edit: true },
				required: true,
				options: [{ id: CURRENT_YEAR, label: CURRENT_YEAR }]
			}),
		[FORM_FIELD_KEYS.DOCUMENT_TYPE]: new RenderConfig()
			.setName('documentType')
			.setLabel('Document Type')
			.setRenderer(SelectInput)
			.setRenderProps({
				isEditable: { create: true, edit: true },
				options: _map(_keys(DOCUMENT_TYPE_OPTIONS), (document: string) => ({
					id: _get(DOCUMENT_TYPE_OPTIONS, document),
					label: document
				})),
				required: true
			}),

		[FORM_FIELD_KEYS.FILE_NAME]: new RenderConfig()
			.setName('fileName')
			.setLabel('Attach the Document')
			.setRenderer(AssetUploadInputOnS3)
			.setRenderProps({
				isEditable: { create: true, edit: true },
				required: true,
				assetType: ASSET_TYPE.MEDIA_PRIVATE_PDF,
				maxFileSizeMB: 5,
				subFolder: 'Form60',
				zupeeUserId: uid
			})
	};

	return FORM_FIELD_CONFIG;
};

export const FORM_LAYOUT_CONFIG = [
	new Row(FORM_FIELD_KEYS.DOCUMENT_TYPE),
	new Row(FORM_FIELD_KEYS.DOCUMENT_NUMBER),
	new Row(FORM_FIELD_KEYS.YEAR),
	new Row(FORM_FIELD_KEYS.FILE_NAME)
];
